import BillingsOrderTaxiRailyRecalculateResponse, {
  BillingsOrderTaxiRailyRecalculateResponseDataBillingNode,
  BillingsOrderTaxiRailyRecalculateResponseDataCargoOrder,
  BillingsOrderTaxiRailyRecalculateResponseDataContract,
  BillingsOrderTaxiRailyRecalculateResponseDataContractCargoCompany,
} from "../../../../../api/raily/billings/order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate.response";
import BillingsOrderTaxiRailyRecalculate, {
  BillingsOrderTaxiRailyRecalculateBillingNode,
  BillingsOrderTaxiRailyRecalculateCargoOrder,
  BillingsOrderTaxiRailyRecalculateContract,
  BillingsOrderTaxiRailyRecalculateContractCargoCompany,
} from "./billings-order-taxi-raily-recalculate";

const createCargoOrder = (
  cargoOrder: BillingsOrderTaxiRailyRecalculateResponseDataCargoOrder,
): BillingsOrderTaxiRailyRecalculateCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
    id: cargoOrder.id,
  };
};

const createContractCargoCompany = (
  cargoCompany: BillingsOrderTaxiRailyRecalculateResponseDataContractCargoCompany,
): BillingsOrderTaxiRailyRecalculateContractCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
  };
};

const createContract = (
  contract: BillingsOrderTaxiRailyRecalculateResponseDataContract,
): BillingsOrderTaxiRailyRecalculateContract => {
  return {
    allowChargeDuringRide: contract.allowChargeDuringRide,
    allowChargeWhileApproaching: contract.allowChargeWhileApproaching,
    allowChargeWhileReturning: contract.allowChargeWhileReturning,
    cargoCompany: createContractCargoCompany(contract.cargoCompany),
    discountLimit: contract.discountLimit,
    distanceRate: contract.distanceRate,
    haltingTimeAfterMinutes: contract.haltingTimeAfterMinutes,
    haltingTimeRate: contract.haltingTimeRate,
    model: contract.model,
  };
};

const createBillingNode = (
  node: BillingsOrderTaxiRailyRecalculateResponseDataBillingNode,
): BillingsOrderTaxiRailyRecalculateBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderTaxiRailyRecalculateResponseDataBillingNode[],
): BillingsOrderTaxiRailyRecalculateBillingNode[] => {
  return nodes.map(createBillingNode);
};

const create = (
  response: BillingsOrderTaxiRailyRecalculateResponse,
): BillingsOrderTaxiRailyRecalculate => {
  const data = response.data;

  return {
    contract: createContract(data.contract),
    billingNodes: createBillingNodes(data.billingNodes),
    cargoOrder: createCargoOrder(data.cargoOrder),
    discount: data.discount,
    discountAmount: data.discountAmount,
    distance: data.distance,
    distanceAmount: data.distanceAmount,
    haltingAmount: data.haltingAmount,
    highwayCharge: data.highwayCharge,
    planEntryId: data.planEntryId,
    totalAmount: data.totalAmount,
  };
};

const billingsOrderTaxiRailyRecalculateFactory = {
  create,
};

export default billingsOrderTaxiRailyRecalculateFactory;
